import React, { createContext, useContext } from 'react';
import type { ComparisonPrefill } from '../pages/comparison/types';

export type { ComparisonPrefill };

export interface ComparisonNavigation {
  openComparison: (prefill: ComparisonPrefill) => void;
}

const ComparisonNavigationContext = createContext<ComparisonNavigation | null>(null);

export function ComparisonNavigationProvider({
  value,
  children,
}: {
  value: ComparisonNavigation;
  children: React.ReactNode;
}) {
  return <ComparisonNavigationContext.Provider value={value}>{children}</ComparisonNavigationContext.Provider>;
}

export function useComparisonNavigation(): ComparisonNavigation | null {
  return useContext(ComparisonNavigationContext);
}
